import React from "react";
import { Helmet } from "react-helmet-async";
import { FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import CmsRenderer from "../../components/CmsRenderer/CmsRenderer";
import ContactForm from "../../components/Contact/ContactForm";
import cmsClient from "../../lib/cmsClient";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import "./Contact.css";

const TRUST = [
  { icon: "⚡", label: "Reponse sous 24h" },
  { icon: "🔒", label: "100% confidentiel" },
  { icon: "🤝", label: "Aucun engagement" },
];

const STEPS = [
  { num: "1", title: "Ecrivez-nous", desc: "Par email ou WhatsApp — au choix. On vous repond rapidement." },
  { num: "2", title: "On etudie votre besoin", desc: "Un consultant analyse votre projet et prepare une reponse adaptee." },
  { num: "3", title: "On vous rappelle sous 24h", desc: "Appel ou message pour affiner votre demande et vous proposer un devis." },
];

export default function Contact() {
  useScrollReveal();
  const [cmsPage, setCmsPage] = React.useState({ blocks: [], theme: {} });

  React.useEffect(() => {
    (async () => {
      try {
        const j = await cmsClient.getPage('contact');
        if (j?.success) setCmsPage(j.data || { blocks: [], theme: {} });
      } catch (_e) {}
    })();
  }, []);

  const hasBlocks = (cmsPage.blocks || []).length > 0;

  return (
    <div>
      <Helmet>
        <title>Contact — NEXUS SOLUTIONS</title>
        <meta name="description" content="Contactez NEXUS SOLUTIONS pour votre projet digital a Abidjan. Email, telephone ou WhatsApp — nous repondons rapidement." />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ContactPage",
          "name": "Contactez NEXUS SOLUTIONS",
          "url": "https://nxs-solutions.com/contact",
          "mainEntity": {
            "@type": "Organization",
            "name": "NEXUS SOLUTIONS",
            "telephone": "+2250142578758",
            "email": "contact@nxs-solutions.com",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Cocody, Angré, Cité des Racines",
              "addressLocality": "Abidjan",
              "addressCountry": "CI"
            }
          }
        })}</script>
      </Helmet>

      {hasBlocks ? (
        <CmsRenderer blocks={cmsPage.blocks} />
      ) : (
        <>
          <div className="contact-hero">
            <h1 data-reveal="">Parlons de votre projet</h1>
            <p data-reveal="" data-delay="80">Reponse garantie sous 24h. Pas de jargon, pas d'engagement.</p>
            <div className="contact-trust">
              {TRUST.map((t, i) => (
                <div className="contact-trust__chip" key={t.label} data-reveal="" data-delay={i * 80}>
                  <span>{t.icon}</span>
                  <span>{t.label}</span>
                </div>
              ))}
            </div>
          </div>

          <section className="contact-process">
            <div className="contact-process__inner">
              <h2 className="contact-process__title" data-reveal="">Comment ca se passe ?</h2>
              <div className="contact-process__steps">
                {STEPS.map((s, i) => (
                  <div className="contact-step" key={s.num} data-reveal="" data-delay={i * 100}>
                    <div className="contact-step__num">{s.num}</div>
                    {i < STEPS.length - 1 && <div className="contact-step__line" aria-hidden />}
                    <div className="contact-step__body">
                      <div className="contact-step__title">{s.title}</div>
                      <div className="contact-step__desc">{s.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </>
      )}

      <main className="contact-page">
        <div className="contact-info-card" data-reveal="">
          <h2>Nos coordonnees</h2>

          <div className="contact-info-item">
            <div className="contact-info-icon"><FaMapMarkerAlt /></div>
            <div>
              <div className="contact-info-label">Adresse</div>
              <a
                href="https://maps.google.com/?q=Cocody+Angre+Cite+des+Racines+Abidjan"
                target="_blank"
                rel="noreferrer"
                className="contact-info-value contact-info-link"
              >
                Cocody, Angre, Cite des Racines<br />Abidjan, Cote d'Ivoire
              </a>
            </div>
          </div>

          <div className="contact-info-item">
            <div className="contact-info-icon"><FaEnvelope /></div>
            <div>
              <div className="contact-info-label">Email</div>
              <a href="mailto:contact@nxs-solutions.com" className="contact-info-value contact-info-link">
                contact@nxs-solutions.com
              </a>
            </div>
          </div>

          {/* <div className="contact-wa-block">
            <div className="contact-wa-block__header">
              <FaWhatsapp size={22} />
              <span>WhatsApp</span>
            </div>
            <p className="contact-wa-block__text">
              Preferez la messagerie instantanee ? On repond generalement dans l'heure.
            </p>
            <a
              href="https://wa.me/2250142578758"
              target="_blank"
              rel="noreferrer"
              className="contact-wa-block__btn"
            >
              Ecrire sur WhatsApp
            </a>
          </div> */}

          <div className="contact-hours">
            <div className="contact-hours__title">Disponibilite</div>
            <div className="contact-hours__row"><span>Lun — Ven</span><span>8h — 18h</span></div>
            <div className="contact-hours__row"><span>Samedi</span><span>9h — 14h</span></div>
            <div className="contact-hours__row"><span>Dimanche</span><span>Sur urgence</span></div>
          </div>
        </div>

        <div className="contact-form-area" data-reveal="">
          <h2>Envoyer un message</h2>
          <p>Pour un projet, une question ou une collaboration — remplissez le formulaire et nous vous repondrons rapidement.</p>
          <ContactForm />
        </div>
      </main>
    </div>
  );
}
